// Referral attribution: capture a ?ref=<code> param and persist it across the
// Auth0 signup round-trip (same approach as trialIntent) so it can be passed into
// checkout, where the backend stamps it onto the subscription for reward issuance.

const REF_KEY = 'pev_ref';
const REF_RE = /^[a-z0-9]{4,16}$/;

const getStore = (storage) =>
  storage || (typeof window !== 'undefined' ? window.localStorage : null);

/** Extract and normalize a referral code from a location.search string (null if invalid). */
export const parseRefCode = (search) => {
  try {
    const code = new URLSearchParams(search || '').get('ref');
    if (!code) return null;
    const normalized = code.trim().toLowerCase();
    return REF_RE.test(normalized) ? normalized : null;
  } catch (e) {
    return null;
  }
};

/** Persist a valid ?ref code (first-touch wins). Returns the parsed code, or null. */
export const captureRefFromUrl = (search, storage) => {
  const code = parseRefCode(search);
  const store = getStore(storage);
  if (!code || !store) return code;
  try {
    if (!store.getItem(REF_KEY)) store.setItem(REF_KEY, code);
  } catch (e) { /* storage unavailable */ }
  return code;
};

export const getStoredRef = (storage) => {
  const store = getStore(storage);
  try { return store ? store.getItem(REF_KEY) : null; } catch (e) { return null; }
};

export const clearStoredRef = (storage) => {
  const store = getStore(storage);
  try { if (store) store.removeItem(REF_KEY); } catch (e) { /* noop */ }
};
